import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHttp } from 'shared/providers/provide-http';
import { NationalAccountUser } from 'types/backend';

export function useGetNationalAccountUsers() {
    const { enqueueSnackbar } = useSnackbar();
    const http = useHttp();
    const nationalAccountUsersResponse = useQuery<NationalAccountUser[], Error>(
        ['nationalAccountUsers'],
        async () => {
            const { data } = await http.get(`api/NationalAccountUsers/GetNationalAccountUsers`);
            return data;
        },
        {
            onError: (error) => enqueueSnackbar(error.message, { variant: 'error' }),
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    );
    return nationalAccountUsersResponse;
}
